<template>
  <div class="new">
    <progressBar
      class="new-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="new-store" v-if="progressActiveIndex === 0">
      <div class="new-store-line">
        <div class="new-store-line__name">店铺:</div>
        <el-select size="mini" v-model="storeName">
          <el-option v-for="item in storeList" :key="item.id" :label="item.storeName" :value="item.storeName"></el-option>
        </el-select>
      </div>
      <div class="new-store-line">
        <div class="new-store-line__name">国家站点:</div>
        <el-select size="mini" v-model="countrySiteIndex">
          <el-option v-for="(item, index) in countrySite" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </div>
    </div>
    <div class="new-listing" v-if="progressActiveIndex === 1">
      <Table
        :head="listingBystoreTableHead"
        :body="listingByStoreAndCountry"
        @clickCheck="changeListingCheck"
        width="1280"
        height="300"
        lineHeight="50"></Table>
    </div>
    <div class="new-num" v-if="progressActiveIndex === 2">
      <div class="new-num-top">
        <div class="new-num-top__name">新建FBA发补货计划单</div>
        <div class="new-num-top__subtitle">(店铺：{{ storeName }};国家站点：{{ countrySite[countrySiteIndex] }})</div>
      </div>
      <div class="new-num-table">
        <Table
          :head="replenishmentNumTableHead"
          :body="replenishmentNumTableBody"
          @changeInput="inputReplenishmentNum"
          width="1280"
          height="350"></Table>
      </div>
    </div>
    <div class="new-bottom">
      <div class="new-bottom-left">
        <template v-if="progressActiveIndex == 2">
          <div class="new-bottom-item">
            <div class="new-bottom-item__name">货件追踪编号</div>
            <el-input size="mini" v-model="replenishmentData.amzonId" placeholder="Amzon ref. ID"></el-input>
          </div>
          <div class="new-bottom-item">
            <div class="new-bottom-item__name">FBA编号</div>
            <el-input size="mini" v-model="replenishmentData.fbaId"></el-input>
          </div>
          <div class="new-bottom-item">
            <div class="new-bottom-item__name">亚马逊仓库代码</div>
            <el-select size="mini" v-model="replenishmentData.warehouseId" placeholder="">
              <el-option
                v-for="item in matrixWarehouseArrayData"
                :key="item.id"
                :value="item.id"
                :label="item.name"></el-option></el-select>
          </div>
          <div class="new-bottom-item">
            <div class="new-bottom-item__name">要求交货日期</div>
            <el-date-picker size="mini" v-model="replenishmentData.deliveryDate" placeholder="选择日期时间"></el-date-picker>
          </div>
        </template>
      </div>
      <div class="new-bottom-right">
        <template v-if="progressActiveIndex != 0">
          <div class="new-bottom__btn" @click="preStep">上一步</div>
        </template>
        <template v-if="isSurplusStock">
          <div class="new-bottom__btn" @click="openTrunkDialog">新建尾箱</div>
        </template>
        <template v-if="progressActiveIndex != progressData.length - 1">
          <div class="new-bottom__btn" @click="nextStep">
            <template v-if="progressActiveIndex == 1">加入FBA发补货计划</template>
            <template v-else-if="progressActiveIndex == 2">生成FBA发补货计划单</template>
            <template v-else>下一步</template>
          </div>
        </template>
      </div>
    </div>
    <Dialog :show="trunkDialogShow" @cancel="cancelTrunkDialog">
      <div class="new-dialog">
        <div class="new-dialog-top">
          <div class="new-dialog__title">新建尾箱</div>
          <div class="new-dialog__subtitle">(注意: "外箱尺寸不同","箱内装不同型号产品" 或 "箱内装相同型号产品但数量不同" 都看作"不同箱型的外箱",必须点击"新建尾箱"分别创建才能保证数据准确!)</div>
        </div>
        <div class="new-dialog-table">
          <Table :head="trunkTableHead" width="1100" height="200" lineHeight="40"></Table>
        </div>
        <div class="new-dialog-info">
          <div class="new-dialog-info__title">尾箱详细信息:</div>
          <div class="new-dialog-info-data">
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">箱型：外箱尺寸：</div>
            <div class="new-dialog-info__size">
              <el-input placeholder="长(cm)" size="mini"></el-input>
              <el-input placeholder="宽(cm)" size="mini"></el-input>
              <el-input placeholder="高(cm)" size="mini"></el-input>
            </div>
            <div class="new-dialog-info__unit">(cm)</div>
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">外箱重量：</div>
            <el-input placeholder="" size="mini"></el-input>
            <div class="new-dialog-info__unit">(kg)</div>
            <div class="new-dialog__star">*</div>
            <div class="new-dialog-info__text">箱数：</div>
            <el-input placeholder="" size="mini"></el-input>
            <div class="new-dialog-info__unit">(箱)</div>
          </div>
          <div class="new-dialog-info__tip">(提示: 在现实场景下, 1. 通常先将尾货装入外箱(如外箱过大可裁切缩小外箱尺寸)；2. 然后再确认箱内产品的型号及数量；3. 然后实量外箱尺寸，实称外箱重量，确认同样尺寸同样装箱内容的外箱数量；4. 然后将确认的数据输入上面的单元格中；5. 点击“新建尾箱”,新建的尾箱信息将保存到“新建亚马逊进仓计划单”内; 6. 同理,如果还有尾货则需要继续重复该流程；)</div>
        </div>
        <div class="new-dialog-bottom">
          <div class="new-dialog__btn" @click="cancelTrunkDialog">新建尾箱</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { ReplenishmentNewModule, ReplenishmentNum, Replenishment } from './class'
import { Listing } from 'views/summary/component/listing/class'
import { DealResult } from 'common/dataClass/Default'
import { LogisticsQuotationAddressMenuOption } from 'common/dataClass/Logistics'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import ProductAxios from 'service/product'
import LogisticsAxios from 'service/logistics'
import globalData from 'common/globalData';
import Dialog from 'components/common/Dialog'
export default {
  name: 'newFBAReplenishment',
  components: {
    progressBar, Table, Dialog
  },
  data(){
    return {
      /**进度条数据 */
      progressData: ReplenishmentNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 0,
      /**国家站点 */
      countrySite: globalData.countrySiteInputOptions,
      countrySiteIndex: null,
      /**选择店铺ID */
      storeName: null,
      /**listing数据 */
      listingList: [],
      listingIndexArray: [],
      listingByStoreAndCountry: [],
      listingBystoreTableHead: ReplenishmentNewModule.NEWLISTINGTABLEHEAD(),
      /**发补货计划单装箱情况表头 */
      replenishmentNumTableHead: ReplenishmentNewModule.NEWNUMTABLEHEAD(),
      replenishmentNumTableBody: [],
      /**创建发补货计划单需要数据 */
      replenishmentData: new Replenishment(),
      matrixWarehouseArrayData: [],
      /**尾箱 */
      trunkDialogShow: false,
      trunkTableHead: ReplenishmentNewModule.NEWTRUNKTABLEHEAD(),
    }
  },
  methods: {
    /**获取仓库代码 */
    async getMatrixWarehouse(){
      this.matrixWarehouseArrayData.splice(0, this.matrixWarehouseArrayData.length)
      let res = await LogisticsAxios.getFbaId({countrySite: this.countrySiteIndex})
      if(res.data.code === 1){
        res.data.info.map(e => {
          this.matrixWarehouseArrayData.push(new LogisticsQuotationAddressMenuOption(e.name, e.id, { show: true }))
        })
      }
    },
    /**上一步 */
    preStep(){
      this.progressActiveIndex --
    },
    /**下一步 */
    nextStep(){
      let func = {
        0: () => {
          if(this.storeId === null || this.countrySiteIndex === null) return new DealResult(1001, '请选择店铺以及国家站点')
          this.listingByStoreAndCountry = this.listingList.filter(item => item.store == this.storeName && item.countrySite == this.countrySiteIndex)
          if(this.listingByStoreAndCountry.length === 0){
            return new DealResult(1000, '该条件下没有产品可选择!')
          }else{
            this.getMatrixWarehouse()
            return new DealResult(1, '下一步')
          }
        },
        1: () => {
          let selectListingArray = this.listingByStoreAndCountry.filter(item => item.check)
          if(selectListingArray.length === 0){
            return new DealResult(1002, '至少选择一个商品')
          }else{
            let obj = new ReplenishmentNum(true)
            obj.importParentData(selectListingArray[0])
            this.replenishmentNumTableBody.splice(0, this.replenishmentNumTableBody.length)
            this.replenishmentNumTableBody.push(obj)
            return new DealResult(1, '下一步')
          }
        }
      }
      let res = func[this.progressActiveIndex]()
      if(res.code === 1){
        this.progressActiveIndex ++
      }else{
        this.$message.error(res.info)
      }
    },
    /**获取listing列表 */
    async getListingList(){
      this.listingList.splice(0, this.listingList.length)
      let obj = {
        "productType": null,
        "export": null,
        "text": null
      }
      let res = await ProductAxios.getWarehousingOption(obj)
      if(res.data.code === 1){
        let array = res.data.info
        array.map(obj => {
          let listingTmp = new Listing()
          listingTmp.backendListDataParsing(obj)
          listingTmp.check = false
          this.listingList.push(listingTmp)
        })
      }else{
        this.$message.error(res.data.info)
      }
    },
    /**listing多选框点击事件 */
    changeListingCheck(index){
      this.listingByStoreAndCountry[index].check = !this.listingByStoreAndCountry[index].check
    },
    /**发补货数量输入事件 */
    inputReplenishmentNum(value, index, key){
      this.replenishmentNumTableBody[index][key] = value
      this.replenishmentNumTableBody[index].numByBox = Math.floor(value / this.replenishmentNumTableBody[index].boxNum)
      this.replenishmentNumTableBody[index].numInBox = this.replenishmentNumTableBody[index].numByBox * this.replenishmentNumTableBody[index].boxNum
      this.replenishmentNumTableBody[index].numByLast = value % this.replenishmentNumTableBody[index].boxNum
      if(this.replenishmentNumTableBody[index].numByBox == this.replenishmentNumTableBody[index].numInBox
        && this.replenishmentNumTableBody[index].numInBox == this.replenishmentNumTableBody[index].numByLast){
        this.replenishmentNumTableBody[index].boxStatus = -1
      }
    },
    /**关闭尾箱弹窗 */
    cancelTrunkDialog(){
      this.trunkDialogShow = false
    },
    /**打开尾箱弹窗 */
    openTrunkDialog(){
      this.trunkDialogShow = true
    }
  },
  created(){
    this.getListingList()
  },
  computed:{
    storeList(){
      return this.$store.state.storeList
    },
    /**是否存在尾货 */
    isSurplusStock(){
      return this.replenishmentNumTableBody.some(item => item.boxStatus === 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1400px;
  &-progress{
    margin-bottom: 5px;
  }
  &-store{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 500px;
    &-line{
      display: flex;
      align-items: center;
      margin: 10px;
      &__name{
        width: 100px;
        margin-right: 5px;
        text-align: end;
      }
    }
  }
  &-num{
    &-top{
      display: flex;
      align-items: end;
      margin: 10px 0;
      &__name{
        font-size: 18px;
        color: black;
        font-weight: bold;
      }
      &__subtitle{
        font-size: 12px;
        color: #00a0c7;
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: space-between;
    &-left{
      display: flex;
    }
    &-right{
      display: flex;
      align-items: end;
    }
    &-item{
      text-align: center;
      margin: 0 5px;
      width: 150px;
      &__name{
        font-weight: bold;
        margin: 2px 0;
      }
      ::v-deep{
        .el-input{
          width: 150px;
        }
        .el-input__inner{
          width: 150px;
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-dialog{
    &-top{
      display: flex;
      align-items: end;
    }
    &__title{
      color: black;
      font-weight: bold;
      font-size: 16px;
    }
    &__subtitle{
      color: #fca605;
      font-size: 12px;
    }
    &__star{
      color: red;
      font-weight: bold;
      font-size: 12px;
    }
    &-info{
      ::v-deep{
        .el-input{
          width: 100px;
        }
        .el-input__inner{
          width: 100px;
        }
      }
      &__title{
        color: #00a0c7;
        font-weight: bold;
        font-size: 14px;
      }
      &-data{
        display: flex;
        align-items: center;
        margin: 5px 0;
      }
      &__text{
        font-size: 14px;
      }
      &__size{
        ::v-deep{
          .el-input{
            width: 80px;
            margin-right: 4px;
          }
          .el-input__inner{
            width: 80px;
          }
        }
      }
      &__unit{
        margin: 0 8px 0 2px;
      }
      &__tip{
        color: #fca605;
      }
    }
    &-bottom{
      display: flex;
      justify-content: end;
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
